import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icon } from "@perxis-auto/ui-kit";
import clsx from "clsx";
import styles from "./SideNav.module.scss.js";
const SideNav = forwardRef(function SideNav2({ onPrevClick, onNextClick, isPrevDisabled, isNextDisabled, className, total = 0, isHidden = false, ...props }, ref) {
  return /* @__PURE__ */ jsxs(
    "nav",
    {
      ref,
      "data-list-length": total,
      className: clsx(styles.sideNav, { [styles["sideNav--hidden"]]: isHidden }, className),
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            "aria-label": "left navigation",
            disabled: isPrevDisabled,
            className: styles.sideNav__button,
            onClick: onPrevClick,
            children: /* @__PURE__ */ jsx(Icon, { name: "back", size: 18, sticker: "comparison-list-side-nav-icon" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            "aria-label": "right navigation",
            disabled: isNextDisabled,
            className: styles.sideNav__button,
            onClick: onNextClick,
            children: /* @__PURE__ */ jsx(Icon, { name: "forward", size: 18, sticker: "comparison-list-side-nav-icon" })
          }
        )
      ]
    }
  );
});
export {
  SideNav
};
